import React from 'react';
import { useAuth } from '../../auth/AuthContext';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/24/outline';

const ImpersonationIndicator = () => {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useAuth();
  const { t } = useTranslation('common');
  const [stopping, setStopping] = React.useState(false);

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  const handleStop = async () => {
    try {
      setStopping(true);
      await stopImpersonation();
      // Optionally reload the page to ensure all components use the restored user context
      window.location.reload();
    } catch (error) {
      console.error('Error stopping impersonation:', error);
      setStopping(false);
    }
  };

  return (
    <div className="bg-yellow-400 border-b border-yellow-500 px-6 py-3">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg
              className="h-5 w-5 text-yellow-800"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <p className="ml-3 text-sm font-medium text-yellow-800">
            {t('impersonation.indicator.impersonating', {
              email: impersonatedUser.email || impersonatedUser.name || 'Unknown User'
            })}
          </p>
        </div>
        <button
          onClick={handleStop}
          disabled={stopping}
          className="ml-4 inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-yellow-800 bg-yellow-500 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {stopping ? (
            <>
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-yellow-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {t('common.loading')}
            </>
          ) : (
            <>
              <XMarkIcon className="h-4 w-4 mr-1" />
              {t('impersonation.indicator.stop')}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ImpersonationIndicator;


